import MapWidget from "../assets/js/map-widget";

const PayByWidget = (totalPrice) => {
  new MapWidget({
    Token: "Jms7xd95Cv30S3Mri7Xfp3md8cn3lxmD5Xb47Hg8Bl9Dm8cF6Hbsl3VgP21Kio9a",
    Amount: totalPrice * 100,
    Currency: "RUB",
    // Receipt: true,
    ProductName: "Заказ №" + Math.floor(Math.random()*9000),
    // Email: email,
    AutoClose: true,
  });
};

export default PayByWidget;
